function scrollAssetTabIntoView(tab) {
  const strip = tab.closest('.asset-with-text__media-tab-scroll');
  if (!strip) return;
  const pad = 8;
  const tabRect = tab.getBoundingClientRect();
  const stripRect = strip.getBoundingClientRect();
  const deltaLeft = tabRect.left - stripRect.left - pad;
  const deltaRight = tabRect.right - stripRect.right + pad;
  if (deltaLeft < 0) {
    strip.scrollBy({ left: deltaLeft, behavior: 'smooth' });
  } else if (deltaRight > 0) {
    strip.scrollBy({ left: deltaRight, behavior: 'smooth' });
  }
}

document.querySelectorAll('[data-media-tabs]').forEach((tabsEl) => {
  tabsEl.querySelectorAll('.asset-with-text__media-tab.is-active').forEach((tab) => {
    requestAnimationFrame(() => scrollAssetTabIntoView(tab));
  });

  tabsEl.querySelectorAll('.asset-with-text__media-tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      const index = tab.dataset.tabTarget;
      const items = tabsEl.querySelectorAll('.asset-with-text__media-item');
      const tabs = tabsEl.querySelectorAll('.asset-with-text__media-tab');

      items.forEach((item) => item.classList.remove('is-active'));
      tabs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });

      tabsEl.querySelector(`.asset-with-text__media-item[data-tab-index="${index}"]`)?.classList.add('is-active');
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      scrollAssetTabIntoView(tab);
    });
  });
});
